module.exports = __webpack_public_path__ + "img/service-1.fa56f439.png";